module.exports = "## Images optimization for consumers\r\n\r\nIf you are a consumer or a photographer, you may want to compress your images to upload them faster. Optimized images also help to stay within file size restrictions on many consumer websites."


//////////////////
// WEBPACK FOOTER
// ./src/containers/CompressImages/image-optimization-consumers.md
// module id = 1140
// module chunks = 0